import { MAX_TAGS_PER_ACTION, TAG_OPS, type TagOp } from "@velizhanin-dev/bot-scenario"
import { Trash2 } from "lucide-react"
import { draftCache } from "@/entities/bot-builder"
import { Button } from "@/shared/ui/button"
import { Field } from "@/shared/ui/form-field"
import { NativeSelect } from "@/shared/ui/native-select"
import type { EditorProps } from "../editor-props"
import { readString } from "../editor-props"
import { issuesAt } from "../issues-text"

const TAG_OP_LABELS: Record<TagOp, string> = {
	add: "Добавить в группы",
	remove: "Убрать из групп",
}

export function TagEditor({ config, onChange, issues, draft }: EditorProps) {
	const op = (readString(config, "op") || "add") as TagOp
	const tagIds = Array.isArray(config.tagIds) ? (config.tagIds as string[]) : []
	const tags = draftCache.pickableTags(draft.tags ?? [], tagIds)
	const available = tags.filter((tag) => !tagIds.includes(tag.id))
	return (
		<div className="space-y-4">
			<Field label="Действие" issues={issuesAt(issues, "op")}>
				<NativeSelect
					aria-label="Действие с меткой"
					value={op}
					onChange={(event) => onChange({ ...config, op: event.target.value })}
				>
					{TAG_OPS.map((value) => (
						<option key={value} value={value}>
							{TAG_OP_LABELS[value]}
						</option>
					))}
				</NativeSelect>
			</Field>
			<Field
				label="Группы"
				issues={issuesAt(issues, "tagIds", true)}
				hint={
					tags.length === 0
						? "Групп пока нет, их создают в «Аналитика → Группы»."
						: "По группам работают условия, фильтр пользователей и рассылки."
				}
			>
				<div className="space-y-2">
					{tagIds.map((tagId, index) => (
						<div key={tagId} className="flex items-center gap-1">
							<span className="min-w-0 flex-1 truncate rounded-md bg-muted px-2 py-1.5 text-sm">
								{tags.find((tag) => tag.id === tagId)?.name ?? "Удалённая группа"}
							</span>
							<Button
								type="button"
								variant="ghost"
								size="icon"
								aria-label={`Убрать метку ${index + 1}`}
								onClick={() => onChange({ ...config, tagIds: tagIds.filter((id) => id !== tagId) })}
							>
								<Trash2 />
							</Button>
						</div>
					))}
					{available.length > 0 && tagIds.length < MAX_TAGS_PER_ACTION ? (
						<NativeSelect
							aria-label="Добавить группу"
							value=""
							onChange={(event) =>
								event.target.value &&
								onChange({ ...config, tagIds: [...tagIds, event.target.value] })
							}
						>
							<option value="">Добавить группу…</option>
							{available.map((tag) => (
								<option key={tag.id} value={tag.id}>
									{tag.name}
								</option>
							))}
						</NativeSelect>
					) : null}
				</div>
			</Field>
		</div>
	)
}
